/* Rquiere de mixin.js */

var team = {
	data() {
		return {
			dateFromTeams: '2020-07-15',
			dateToTeams: '2020-07-18',
			listTeams: [],
			methodsTeam: {
				create: 'team/register',
				delete: '/delete',
				get: 'teams',
				show: 'team/',
				showFull: 'teamFull/'
			},
			objectTeam: {
				exists: 0,
				id: 0,
				name: '',
				description: '',
				begin_date: '',
				end_date: null,
				client_id: 0,
				client: {},
				entity_id: 0,
				entity: {},
				status_id: 0,
				status: {},
				orders: [],
				consignments: [],
				created_at: '',
				updated_at: ''
			},
			qRowsTeam: 25,
			paginationTeams: [],
			searchTeams: '',
		}
	},
	computed: {
	},
	filters: {
	},
	methods: {
		addListTeams(newTeam) {
			this.listTeams.unshift(newTeam)
			if (this.listTeams.length > this.qRowsTeam) {
				this.listTeams.splice(this.qRowsTeam, 1)
			}
		},
		deleteItemListTeam(id) {
			let index = this.listTeams.map((el) => parseInt(el.id)).indexOf(parseInt(id))
			let teamDeleted = this.listTeams.splice(index, 1)
		},
		deleteTeam(id) {
			this.$emit('showLockScreen', 'Borrando campaña . . .')
			this.axiosActionIS(this.apiBackend + this.methodsTeam.show + id + this.methodsTeam.delete, 'DELETE', 'deleteTeamResult')
		},
		deleteTeamResult(response) {
			if (response.data.success === true) {
				this.deleteItemListTeam(response.data.data)
				this.socketEmit(['DELETE_TEAM'], response.data.data)
			}
			this.deleteTeamResultLocal(response)
		},
		deleteTeamResultLocal(response) {
			console.log('deleteTeamResultLocal no desarrollado', response)
		},
		changeQRowsTeam() {
			localStorage.setItem('qRowsTeam', this.qRowsTeam)
			this.changeQRowsTeamLocal()
		},
		changeQRowsTeamLocal() {
			console.log('changeQRowsTeamLocal no desarrollado')
		},
		clearObjectTeam() {
			this.objectTeam.exists = 0
			this.objectTeam.id = 0
			this.objectTeam.name = ''
			this.objectTeam.description = ''
			this.objectTeam.begin_date = this.currentDate()
			this.objectTeam.end_date = null
			this.objectTeam.client_id = 0
			this.objectTeam.client = {}
			this.objectTeam.entity_id = 0
			this.objectTeam.entity = {}
			this.objectTeam.status_id = 0
			this.objectTeam.status = {}
			this.objectTeam.orders = [],
				this.objectTeam.consignments = [],
				this.objectTeam.created_at = null
			this.objectTeam.updated_at = null
		},
		getAllTeams(page = 1, statusId = -1) {
			this.listTeams = []
			this.paginationTeams = []
			let parameters = '?search=' + this.searchTeams + '&page=' + page + '&qRow=' + this.qRowsTeam + '&fromDate=' + this.dateFromTeams + '&toDate=' + this.dateToTeams + '&statusId=' + statusId
			this.$emit('showLockScreen', 'Obteniendo lista de Campañas . . .')
			let url = this.apiBackend + this.methodsTeam.get + parameters
			this.axiosActionIS(url, 'GET', 'getAllTeamsResult')
		},
		getAllTeamByUserClient(page = 1, statusId = -1) {
			this.listTeams = []
			this.paginationTeams = []
			let parameters = '?search=' + this.searchTeams + '&page=' + page + '&qRow=' + this.qRowsTeam + '&fromDate=' + this.dateFromTeams + '&toDate=' + this.dateToTeams + '&statusId=' + statusId
			this.$emit('showLockScreen', 'Obteniendo lista de Campañas . . .')
			let url = this.apiBackend + this.methodsTeam.get + '/byUserClient' + parameters
			console.log(url)
			this.axiosActionIS(url, 'GET', 'getAllTeamsResult')
		},
		getAllTeamsResult(response) {
			if (response.data.success === true) {
				this.listTeams = response.data.data
				this.paginationTeams = response.data.paginate
			}
			this.getAllTeamsResultLocal(response)
		},
		getAllTeamsResultLocal(response) {
			console.log('getAllTeamsResultLocal no desrrollado', response)
		},
		saveTeam() {
			let method = (this.objectTeam.exists == 0) ? 'POST' : 'PUT'
			this.$emit('showLockScreen', 'Guardando datos . . .')
			console.log(this.apiBackend + this.methodsTeam.create, this.objectTeam)
			if (method == 'POST') {
				this.axiosActionIS(this.apiBackend + this.methodsTeam.create, method, 'saveTeamResult', this.objectTeam)
			} else {
				//this.axiosActionIS(this.apiBackend + this.methodsTeam.show + this.objectTeam.id, method, 'saveTeamResult', this.objectTeam)
			}
		},
		saveTeamResult(response) {
			if (response.data.success === true) {
				if (response.data.message == 'NEW') {
					this.$snotify.success('Campaña creada con el código ' + response.data.data.id, 'Nueva Campaña')
					this.addListTeams(response.data.data)
					this.socketEmit(['NEW_TEAM'], response.data.data)
				} else if (response.data.message == 'UPDATED') {
					this.$snotify.info('Se ha actualizado la Campaña ' + response.data.data.name + ' con exito!!!', 'Actualizado')
					this.socketEmit(['UPDATE_TEAM'], response.data.data)
					this.updateListTeam(response.data.data)
				}
				this.setObjectTeam(response.data.data)
			}
			this.saveTeamResultLocal(response)
		},
		saveTeamResultLocal(response) {
			console.log('saveTeamResultLocal no desarrollado', response)
		},
		setListeningTeam() {
			this.sockets.subscribe('DELETE_TEAM', (data) => { this.deleteItemListTeam(data.body) })
			this.sockets.subscribe('NEW_TEAM', (data) => { this.addListTeams(data.body) })
			this.sockets.subscribe('UPDATE_TEAM', (data) => { this.updateListTeam(data.body) })
		},
		setObjectTeam(item) {
			let newItem = Object.create(item)
			for (const property in newItem) {
				this.objectTeam[property] = newItem[property]
			}
		},
		setTeamInit() {
			this.qRowsTeam = (localStorage.getItem('qRowsTeam') === null) ? this.qRowsTeam : localStorage.getItem('qRowsTeam')
			this.dateFromTeams = this.currentDate(-180)
			this.dateToTeams = this.currentDate()
			this.setListeningTeam()
			this.setTeamInitLocal()
		},
		showTeam(id, action = 'view') {
			let param = '?action=' + action
			this.axiosActionIS(this.apiBackend + this.methodsTeam.show + id + param, 'GET', 'showTeamResult', null)
		},
		showTeamFull(id, action = 'view') {
			let param = '?action=' + action
			this.axiosActionIS(this.apiBackend + this.methodsTeam.showFull + id + param, 'GET', 'showTeamResult', null)
		},
		showTeamResult(response) {
			if (response.data.success === true) {
				this.setObjectTeam(response.data.data)
			}
			this.showTeamResultLocal(response)
		},
		showTeamResultLocal(response) {
			console.log('showTeamResultLocal no desarrollado', response)
		},
		updateListTeam(item) {
			let index = this.listTeams.map((el) => parseInt(el.id)).indexOf(parseInt(item.id))
			if (index > -1) {
				let newItem = Object.create(item)
				for (const property in newItem) {
					this.listTeams[index][property] = newItem[property]
				}
			}
		}
	},
};

export default team;